import { useEffect, useState } from 'react';

import { postHeartbeat } from '../../services/heartbeat/post';

export const useHeartbeatService = (
	endpoint: string,
	onAuthenticationFailed?: () => void,
	onBadRequest?: () => void,
) => {
	const [nextCallTimestamp, setNextCallTimestamp] = useState<Date | void>(undefined);
	const [sessionExpiryTimestamp, setSessionExpiryTimestamp] = useState<Date | void>(undefined);
	const [callHeartbeatService, setCallHeartbeatService] = useState<boolean>(false);
	const [deactivated, setDeactivated] = useState<boolean>(false);

	useEffect(() => {
		if (callHeartbeatService && endpoint && !deactivated) {
			const callAsync = async () => {
				try {
					const response = await postHeartbeat(endpoint, onAuthenticationFailed, onBadRequest);
					setCallHeartbeatService(false);
					if (response && response.nextCallTimestamp) {
						setNextCallTimestamp(new Date(response.nextCallTimestamp));
					}

					if (response && response.sessionExpiryTime) {
						setSessionExpiryTimestamp(new Date(response.sessionExpiryTime));
					}
				} catch (error) {
					setDeactivated(true);
				}
			};

			callAsync();
		}
	}, [callHeartbeatService, endpoint, onAuthenticationFailed, onBadRequest, deactivated]);

	return {
		nextCallTimestamp,
		sessionExpiryTimestamp,
		callHeartbeatService,
		setCallHeartbeatService,
		deactivated,
	};
};
